// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:28Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import SigningResult from "./types/SigningResult";
// @ts-ignore - not used import
import ModuleCode from "./types/ModuleCode";
// @ts-ignore - not used import
import SigningStatus from "./types/SigningStatus";
// @ts-ignore - not used import
import SigningRequest from "./types/SigningRequest";
// @ts-ignore - not used import
import CertificateInfo from "./types/CertificateInfo";
// @ts-ignore - not used import
import PluginInfoVO from "./types/PluginInfoVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 *  Generated from cz.marbes.qsign.controller.CustomSignApi.
 */
export default class CustomSignApi {
    /**
     * Vlastní získání certifikátů rozšířené o identifikátor requestDocumentId.
     *
     * @param requestId unikátní identifikátor pro získání certifikátů
     * @param metadata metadata pro pdf view komponentu
     * @param ignoreMc ignorovat načítání certifikátů přes MC
     * @return seznam certifikátů
     */
    static getCertificatesCustom(requestId : string, metadata : string, ignoreMc : boolean, config?: {cancelToken?: CancelToken}) : Promise<CertificateInfo[]> {
        return unwrapResponse<CertificateInfo[]>(CustomSignApi.raw.getCertificatesCustom(requestId, metadata, ignoreMc, config));
    }
    /**
     * Získání seznamu aktivních modulů.
     *
     * @return seznam modulů
     */
    static getActiveModules(config?: {cancelToken?: CancelToken}) : Promise<ModuleCode[]> {
        return unwrapResponse<ModuleCode[]>(CustomSignApi.raw.getActiveModules(config));
    }
    /**
     * Získání informace o aktuálnosti verze pluginu.
     *
     * @param requestId identifikátor pro získání verze
     * @return info o pluginu
     */
    static getPluginInfo(requestId : string, config?: {cancelToken?: CancelToken}) : Promise<PluginInfoVO> {
        return unwrapResponse<PluginInfoVO>(CustomSignApi.raw.getPluginInfo(requestId, config));
    }
    /**
     * Získání aktuální verze pluginu.
     *
     */
    static downloadPlugin(config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(CustomSignApi.raw.downloadPlugin(config));
    }
    /**
     * Získání seznamu certifikátů.
     *
     * @param requestId unikátní identifikátor pro získání certifikátů
     * @return seznam certifikátů
     */
    static getCertificates(requestId : string, config?: {cancelToken?: CancelToken}) : Promise<CertificateInfo[]> {
        return unwrapResponse<CertificateInfo[]>(CustomSignApi.raw.getCertificates(requestId, config));
    }
    /**
     * Získání stavu průběhu podepisování.
     *
     * @param signingId unikátní identifikátor podepisování
     * @return stav průběhu podepisování
     */
    static statusSigning(signingId : string, config?: {cancelToken?: CancelToken}) : Promise<SigningStatus> {
        return unwrapResponse<SigningStatus>(CustomSignApi.raw.statusSigning(signingId, config));
    }
    /**
     * Zahájení podepisování.
     *
     * @param signingRequest parametry podepisování
     * @return informace zahájeného podepisování
     */
    static startSigning(signingRequest : SigningRequest, config?: {cancelToken?: CancelToken}) : Promise<SigningResult> {
        return unwrapResponse<SigningResult>(CustomSignApi.raw.startSigning(signingRequest, config));
    }
    /**
     * Zrušení probíhajícího podepisování.
     *
     * @param signingId unikátní identifikátor podepisování
     */
    static cancelSigning(signingId : string, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(CustomSignApi.raw.cancelSigning(signingId, config));
    }

    static raw = {
            getCertificatesCustom: function(requestId : string, metadata : string, ignoreMc : boolean, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<CertificateInfo[]>> {
                const uri = `/qsign/api/sign/certificates/custom`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = { requestId, metadata, ignoreMc };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<CertificateInfo[]>>(finalUri, finalConfig);
            },
            getActiveModules: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<ModuleCode[]>> {
                const uri = `/qsign/api/sign/modules/active`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<ModuleCode[]>>(finalUri, finalConfig);
            },
            getPluginInfo: function(requestId : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<PluginInfoVO>> {
                const uri = `/qsign/api/sign/plugin-info`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = { requestId };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<PluginInfoVO>>(finalUri, finalConfig);
            },
            downloadPlugin: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/sign/plugin-download`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, any>(finalUri, finalConfig);
            },
            getCertificates: function(requestId : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<CertificateInfo[]>> {
                const uri = `/qsign/api/sign/certificates`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = { requestId };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<CertificateInfo[]>>(finalUri, finalConfig);
            },
            statusSigning: function(signingId : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SigningStatus>> {
                const uri = `/qsign/api/sign/${signingId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<SigningStatus>>(finalUri, finalConfig);
            },
            startSigning: function(signingRequest : SigningRequest, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SigningResult>> {
                const uri = `/qsign/api/sign/init`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SigningResult>>(finalUri, UpdateMethods.updateSigningRequest_C85543(signingRequest), finalConfig);
            },
            cancelSigning: function(signingId : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/sign/${signingId}/cancel`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, 0, finalConfig);
            },
    }
}
